import { __awaiter } from "tslib";
import { getSelectors } from "../reducers/selectors";
import { invokeUserDefinedFunction } from "./invokeUserDefinedFunction";
/**
 * Invoke user defined function
 *
 * Called from various other async thunks initiating a reset
 *
 * @param options
 * @returns
 */
export function invokeUserDefinedFunctionSimple(options) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const rootState = getState();
        const selectors = getSelectors(rootState);
        const response = yield dispatch(invokeUserDefinedFunction({
            name: options.name,
            params: {
                input: options.input,
                path: options.path,
                selectors,
            },
        }));
        return response.output;
    });
}
//# sourceMappingURL=invokeUserDefinedFunctionSimple.js.map